import styled from 'styled-components';

export const NotificationBox = styled.div`
  height: auto;
  padding: 12px 0px;
  border-radius: 4px;
  background-color: #e5eeff;
  margin-top: 16px;
  display: flex;
  align-content: flex-start;
`;

export const NotificationParagraph = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 18px;
  color: #081f2b;
  text-align: left;
  width: auto;
  height: auto;
`;

export const QuestionIcon = styled.img`
  margin: 0px 12px;
`;
